import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from '@/constants/common'
import { getCookieValue, persistToken, postMessageToWebView } from '@/utils/helper'

import refreshCoordinator from './refreshCoordinator'

const AUTH_TOKENS_UPDATED_EVENT = 'auth-tokens-updated'

export function triggerLogout() {
  if (typeof window !== 'undefined' && 'ReactNativeWebView' in window) {
    postMessageToWebView(window, { code: 'ERR_001', message: 'logout' })
  } else if (typeof window !== 'undefined') {
    window.location.reload()
  }
}

/**
 * Attempt to refresh tokens on 401. Persists new tokens to cookies,
 * notifies WebView via refreshCoordinator (INFO_001), and dispatches
 * auth-tokens-updated so AuthProvider can sync React state.
 * Call triggerLogout() on failure (e.g. no refresh token or refresh API failed).
 *
 * Used by the main axios interceptor (config.ts) and by BL kheti/locus/ondc
 * responseInterceptorErrCb so all API domains get 401 refresh handling.
 */
export async function handle401Refresh(): Promise<boolean> {
  const currentRefreshToken = getCookieValue(REFRESH_TOKEN_KEY)
  if (!currentRefreshToken) {
    triggerLogout()
    return false
  }

  try {
    const authToken = await refreshCoordinator.refresh(currentRefreshToken)
    if (!authToken) {
      triggerLogout()
      return false
    }
    persistToken(ACCESS_TOKEN_KEY, authToken.access_token, authToken.expires_in)
    persistToken(REFRESH_TOKEN_KEY, authToken.refresh_token, authToken.refresh_expires_in)
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(AUTH_TOKENS_UPDATED_EVENT))
    }
    return true
  } catch {
    triggerLogout()
    return false
  }
}

export { AUTH_TOKENS_UPDATED_EVENT }
